'use strict';

/**
 *  1) Styles at the top of file.
 *  !!! Do not delete, this is for webpack building. !!! All scss files must be included in /assets/src/scss/main.scss
 */
import '../scss/main.scss';

/**
 * 2) Import External (3d-part) JS/jQuery Libs, Extensions like: bootstrap, datepicker, fadeSlider, ect.
 * ! Import Only required components of Bootstrap (NOT whole library).
 */
import Modal from 'bootstrap/js/dist/modal';

/**
 *  3) Your custom modules and call function here
 */
import "slick-carousel/slick/slick.js";

// import { testJqueryFunc1, testJqueryFunc2 } from "./modules/test-import-jquery-func";
import { ajaxStartExample } from "./modules/ajax-start-example";
import { ajaxFilter } from "./modules/ajax-filter";
jQuery(document).ready(function ($) {
  ajaxFilter($);
  var rellax = new Rellax('.rellax');
});

//header burger menu
document.getElementById('burgerMenu').addEventListener('click', function () {
  this.classList.toggle('open');
  document.getElementById('navMenu').classList.toggle('open');
});

//footer accordian
jQuery(document).ready(function ($) {
  function setupAccordionMenu() {
    if ($(window).width() < 992) {
      $('#menu-footer-main-menu .submenu-toggle').remove();
      $('#menu-footer-main-menu li.menu-item-has-children > a').each(function () {
        if (!$(this).next('.submenu-toggle').length) {
          $(this).after('<span class="submenu-toggle plus"></span>');
        }
      });
      $('.submenu-toggle').off('click').on('click', function () {
        $(this).siblings('ul').slideToggle();
        $(this).toggleClass('plus minus');
      });
      $('#menu-footer-main-menu ul').hide();
    } else {
      $('#menu-footer-main-menu ul').show();
      $('.submenu-toggle').remove();
    }
  }
  setupAccordionMenu();
  $(window).resize(function () {
    setupAccordionMenu();
  });
});

//mobile menu accordian
jQuery(document).ready(function ($) {
  function setupAccordionMenu2() {
    var menuIds = ['#menu-header-top-menu-1', '#menu-header-main-menu-1', '#menu-header-top-quick-links-1'];
    if ($(window).width() < 992) {
      menuIds.forEach(function (menuId) {
        $(menuId + ' .submenu-toggle').remove();
        $(menuId + ' li.menu-item-has-children > a').each(function () {
          if (!$(this).next('.submenu-toggle').length) {
            $(this).after('<span class="submenu-toggle plus"></span>');
          }
        });
        $(menuId + ' .submenu-toggle').off('click').on('click', function () {
          $(this).siblings('.sub-menu').slideToggle();
          $(this).toggleClass('plus minus');
        });
        $(menuId + ' .sub-menu').hide();
      });
    } else {
      menuIds.forEach(function (menuId) {
        $(menuId + ' .sub-menu').show();
        $(menuId + ' .submenu-toggle').remove();
      });
    }
  }
  setupAccordionMenu2();
  $(window).resize(function () {
    setupAccordionMenu2();
  });
});

//header menu
jQuery(document).ready(function ($) {
  var svgIcon = "\n  <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\">\n  <path d=\"M7 12H17M17 12L13 8M17 12L13 16\" stroke=\"white\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n</svg>\n";
  $('#menu-header-top-menu a.nav-link[target="_blank"]').each(function () {
    var $link = $(this);
    $link.append(' ' + '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M16 6H11.5558M16 6L15.9998 10.4444M16 6L8 14" stroke="#9E9E9E" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  });
  $('#menu-header-top-menu > .menu-item.menu-item-has-children > a.nav-link').each(function () {
    var $link = $(this);
    $link.append(' ' + '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M15 11L12 14L9 11" stroke="#9E9E9E" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  });
  $('.menu-item-has-children').each(function () {
    var parentLink = $(this).children('a.nav-link').clone();
    var submenuWrapper = $(this).children('.sub-menu__wrapper');
    if (submenuWrapper.length > 0) {
      var customSubmenuWrapper = $('<div class="custom-submenu-layout d-flex container py-1"></div>');
      var leftColumn = $('<div class="left-column"></div>');
      var middleColumn = $('<div class="middle-column"></div>');
      var rightColumn = $('<div class="right-column"></div>');
      leftColumn.append('<div class="parent-link-text">' + parentLink.text() + '</div>');
      var parentLinkTitle = $(this).children('a.nav-link').attr('title');
      if (parentLinkTitle) {
        var button = $('<a href="' + $(this).children('a.nav-link').attr('href') + '"><button class="button-primary">' + parentLinkTitle + '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none"><path d="M7 12.3567H17M17 12.3567L13 8.35669M17 12.3567L13 16.3567" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg></button></a>');
        leftColumn.append(button);
      }
      submenuWrapper.find('.sub-menu > li').each(function () {
        var submenuItemLink = $('<a></a>').attr('href', $(this).children('a.nav-link').attr('href')).addClass('nav-link');
        var submenuItemWrapper = $('<div class="submenu-item-wrapper"></div>');
        var imageSrc = $(this).attr('data-image');
        if (imageSrc) {
          var imageElement = $('<img>').attr('src', imageSrc).addClass('submenu-item-image');
          submenuItemWrapper.append(imageElement);
        }
        var linkWrapper = $('<div class="link-wrapper"></div>');
        var linkText = $('<p class="nav-link"></p>').text($(this).children('a.nav-link').text());
        var svgIcon = $('<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">' + '<path d="M7 12H17M17 12L13 8M17 12L13 16" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>');
        linkText.append(svgIcon);
        linkWrapper.append(linkText);
        submenuItemLink.append(submenuItemWrapper.append(linkWrapper));
        middleColumn.append(submenuItemLink);
      });
      var img = $(this).children('a.nav-link').find('.submenu-image').clone();
      if ($(this).attr('data-description')) {
        rightColumn.append(img).append('<div class="parent-description">' + '<h5>' + $(this).attr('data-subtitle') + '</h5>' + $(this).attr('data-description') + '</div>');
      } else {
        rightColumn.append(img);
      }
      customSubmenuWrapper.append(leftColumn).append(middleColumn).append(rightColumn);
      submenuWrapper.html(customSubmenuWrapper);
      submenuWrapper.addClass('d-none');
      $(this).children('a.nav-link').on('click', function (e) {
        e.preventDefault();
        var isOpen = submenuWrapper.hasClass('d-none');
        $('.sub-menu__wrapper').addClass('d-none');
        $('.menu-item-has-children').removeClass('submenu-open');
        if (isOpen) {
          submenuWrapper.removeClass('d-none');
          $(this).parent().addClass('submenu-open');
        }
      });
    }
  });
  $(document).on('click', function (e) {
    if (!$(e.target).closest('.menu-item-has-children').length) {
      $('.sub-menu__wrapper').addClass('d-none');
      $('.menu-item-has-children').removeClass('submenu-open');
    }
  });
  $('.menu-item-has-children').on('click', function (e) {
    e.stopPropagation();
  });
});

//slick slider
jQuery(document).ready(function ($) {
  $('.text-slider-banner-section').each(function () {
    var $wrapper = $(this);
    var $slider = $wrapper.find('.text-slider');
    var $slideCounter = $wrapper.find('.slide-counter');
    var $prevArrow = $wrapper.find('.slick-prev');
    var $nextArrow = $wrapper.find('.slick-next');

    // Initialize the Slick slider
    $slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 500,
      dots: false,
      infinite: true,
      arrows: false
    });

    // Navigate to previous slide
    $prevArrow.on('click', function () {
      $slider.slick('slickPrev');
    });

    // Navigate to next slide
    $nextArrow.on('click', function () {
      $slider.slick('slickNext');
    });

    // Update slide counter after slide change
    $slider.on('afterChange', function (event, slick, currentSlide) {
      var totalSlides = slick.slideCount;
      var current = currentSlide + 1;
      $slideCounter.text(current + '/' + totalSlides);

      // Call function to set equal height after slide change
      setEqualHeight($slider);
    });

    // Set equal height for slides
    setEqualHeight($slider);

    // Recalculate heights on window resize
    $(window).on('resize', function () {
      setEqualHeight($slider);
    });
  });

  // Function to set equal height for slides
  function setEqualHeight($slider) {
    var maxHeight = 0;

    // Reset height
    $slider.find('.slick-slide').css('height', 'auto');

    // Calculate max height
    $slider.find('.slick-slide').each(function () {
      var thisHeight = $(this).outerHeight();
      if (thisHeight > maxHeight) {
        maxHeight = thisHeight;
      }
    });

    // Set all slides to max height
    $slider.find('.slick-slide').css('height', maxHeight + 'px');
  }
});
jQuery(document).ready(function ($) {
  $('.fullwidth-slider-slider').slick({
    prevArrow: $('.slick-prev'),
    nextArrow: $('.slick-next'),
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
    dots: true,
    infinite: true,
    customPaging: function customPaging(slider, i) {
      return '<div class="custom-dot"></div>';
    }
  });
  // $('.fullwidth-slider-slider').on('afterChange', function (event, slick, currentSlide) {
  //   let totalSlides = slick.slideCount;
  //   let current = currentSlide + 1;
  //   $('.slide-counter').text(current + '/' + totalSlides);
  // });
  $('.fullwidth-slider-hover-area.left').on('click', function () {
    $('.fullwidth-slider-slider').slick('slickPrev');
  });
  $('.fullwidth-slider-hover-area.right').on('click', function () {
    $('.fullwidth-slider-slider').slick('slickNext');
  });
  $('.home-slider').slick({
    prevArrow: $('.slick-prev'),
    nextArrow: $('.slick-next'),
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
    dots: false,
    infinite: true,
    adaptiveHeight: true
  });
  $('.home-slider').on('afterChange', function (event, slick, currentSlide) {
    var totalSlides = slick.slideCount;
    var current = currentSlide + 1;
    $('.slide-counter').text(current + '/' + totalSlides);
  });
  $('.home-slider-hover-area.left').on('click', function () {
    $('.home-slider').slick('slickPrev');
  });
  $('.home-slider-hover-area.right').on('click', function () {
    $('.home-slider').slick('slickNext');
  });
});
jQuery(document).ready(function ($) {
  $('.slider-slider').each(function (index) {
    var $slider = $(this);
    $slider.slick({
      slidesToShow: 3,
      slidesToScroll: 2,
      responsive: [{
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          speed: 1500
        }
      }, {
        breakpoint: 770,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 1000
        }
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 500
        }
      }],
      arrows: false,
      infinite: false,
      centerMode: false,
      variableWidth: true
    });
    var $prevBtn = $slider.siblings('.slider-hover-area.left');
    var $nextBtn = $slider.siblings('.slider-hover-area.right');
    $prevBtn.on('click', function () {
      console.log('Prev button clicked for slider:', index);
      $slider.slick('slickPrev');
    });
    $nextBtn.on('click', function () {
      console.log('Next button clicked for slider:', index);
      $slider.slick('slickNext');
    });
  });
});
var slider = document.querySelector('.product-slider');
var slides = document.querySelectorAll('.product-slide');
var navItems = document.querySelectorAll('.product-slider-navigation span');
var currentSlide = 0;
function moveToSlide(slideIndex) {
  var totalSlides = slides.length;
  if (slideIndex >= totalSlides) {
    currentSlide = 0;
  } else if (slideIndex < 0) {
    currentSlide = totalSlides - 1;
  } else {
    currentSlide = slideIndex;
  }
  if (slides[0]) {
    var slideWidth = slides[0].offsetWidth;
    var margin = parseInt(getComputedStyle(slides[0]).marginRight);
    var totalSlideWidth = slideWidth + margin;
    var halftotalSlides = totalSlides / 2;
    halftotalSlides = halftotalSlides - 0.5;
    var offset = -((currentSlide - halftotalSlides) * totalSlideWidth);
    slider.style.transform = "translateX(".concat(offset, "px)");

    // Update active class for navigation items
    navItems.forEach(function (item, index) {
      item.classList.toggle('active', index === currentSlide);
    });
  }
}

// Event listener for navigation items
navItems.forEach(function (item, index) {
  item.addEventListener('click', function () {
    moveToSlide(index);
  });
});

// Initialize the slider to the first slide
moveToSlide(0);

// Resize event listener to adjust slider position
jQuery(window).resize(function ($) {
  var activeSlideIndex = parseInt(jQuery('.product-slider-navigation span.active').attr('data-slide'));
  moveToSlide(activeSlideIndex);
});

// Click event for the left hover area
jQuery(document).ready(function ($) {
  $('.product-slider-hover-area.left').on('click', function () {
    var activeSlideIndex = parseInt(jQuery('.product-slider-navigation span.active').attr('data-slide'));
    moveToSlide(activeSlideIndex - 1);
  });

  // Click event for the right hover area
  $('.product-slider-hover-area.right').on('click', function () {
    var activeSlideIndex = parseInt(jQuery('.product-slider-navigation span.active').attr('data-slide'));
    moveToSlide(activeSlideIndex + 1);
  });
});
jQuery(document).ready(function ($) {
  $('.banner-slider').slick({
    dots: true,
    infinite: true,
    speed: 500,
    prevArrow: $('.slick-prev'),
    nextArrow: $('.slick-next'),
    fade: true,
    cssEase: 'linear',
    customPaging: function customPaging(slider, i) {
      return '<div class="custom-dot"></div>';
    }
  });
  $('.banner-slider').on('afterChange', function (event, slick, currentSlide) {
    var totalSlides = slick.slideCount;
    var current = currentSlide + 1;
    $('.banner-slide-counter').text(current + '/' + totalSlides);
  });
  $('.banner-slider').on('afterChange', function (event, slick, currentSlide) {
    var totalSlides = slick.slideCount;
    var current = currentSlide + 1;
    $('.banner-slide-counter').text(current + '/' + totalSlides);
  });
});
if (document.getElementById('toggleButton')) {
  document.getElementById('toggleButton').addEventListener('click', function () {
    this.classList.toggle('active');
    var dropdownMenu = document.getElementById('dropdownMenu');
    dropdownMenu.classList.toggle('show');
  });
}

//tabs
jQuery(document).ready(function ($) {});
jQuery(document).ready(function ($) {
  function initSlickSlider() {
    if ($(window).width() <= 991.9) {
      if (!$('.mission-tabs').hasClass('slick-initialized')) {
        $('.mission-tabs').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          infinite: false,
          prevArrow: '<button type="button" class="slick-prev button-primary"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none"><path d="M13 15.3562L10 12.3562L13 9.3562" stroke="white" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
          nextArrow: '<button type="button" class="slick-next button-primary"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none"><path d="M11 9.3562L14 12.3562L11 15.3562" stroke="white" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
          responsive: [{
            breakpoint: 576,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }]
        }).on('afterChange', function (event, slick, currentSlide) {
          var totalSlides = slick.slideCount;
          var slidesToShow = slick.options.slidesToShow;
          var slidesToScroll = slick.options.slidesToScroll;
          if (currentSlide + slidesToShow >= totalSlides) {
            $('.mission-tabs .slick-next').hide();
          } else {
            $('.mission-tabs .slick-next').show();
          }
          if (currentSlide === 0) {
            $('.mission-tabs .slick-prev').hide();
          } else {
            $('.mission-tabs .slick-prev').show();
          }
        });
      }
    } else {
      if ($('.mission-tabs').hasClass('slick-initialized')) {
        $('.mission-tabs').slick('unslick');
      }
    }

    // Re-attach click events every time you re-initialize or destroy the slider
    attachMissionTabClickEvents();
  }

  // Attach click event to .mission-tab elements
  function attachMissionTabClickEvents() {
    $('.mission-tab').off('click').on('click', function () {
      var missionID = $(this).data('mission-id');
      $('.mission-tab').removeClass('active');
      $(this).addClass('active');
      $.ajax({
        url: think_localize_obj.ajax_url,
        type: 'POST',
        data: {
          action: 'load_mission_products',
          mission_id: missionID
        },
        success: function success(response) {
          $('#mission-products').html(response);

          // Re-attach product toggle click events
          jQuery(document).ready(function ($) {
            $('.toggle-product-details').on('click', function () {
              $('.toggle-product-details').removeClass('active');
              $(this).addClass('active');
              var productID = $(this).closest('.product-item').data('product-id');
              var productDetails = $('.product-details[data-product-id="' + productID + '"]');
              var productListSection = $(this).closest('.product-list');
              productListSection.find('.product-details').slideUp();
              var clickedProduct = $(this).closest('.product-item');
              var productsPerRow = window.innerWidth < 992 ? 2 : 6;
              var productIndex = clickedProduct.index();
              var totalProducts = productListSection.find('.product-item').length;
              var insertAfterIndex = Math.floor(productIndex / productsPerRow) * productsPerRow + (productsPerRow - 1);
              if (insertAfterIndex >= totalProducts) {
                insertAfterIndex = totalProducts - 1;
              }
              var rowEndProduct = productListSection.find('.product-item').eq(insertAfterIndex);
              if (productDetails.is(':visible')) {
                productDetails.slideUp();
              } else {
                productDetails.insertAfter(rowEndProduct).slideDown();
              }
            });
          });
        },
        error: function error() {
          alert('Error loading products.');
        }
      });
    });
  }

  // Initialize slider
  initSlickSlider();

  // Call initSlickSlider on resize, but do not trigger the first tab click again
  $(window).resize(function () {
    initSlickSlider();
  });

  // Trigger the first tab click only when the page initially loads
  $('.mission-tab').first().trigger('click');
});

//section padding
document.addEventListener("DOMContentLoaded", function () {
  var sections = document.querySelectorAll('section');
  sections.forEach(function (section) {
    var nextSection = section.nextElementSibling;
    if (nextSection) {
      var currentBgColor = window.getComputedStyle(section).backgroundColor;
      var nextBgColor = window.getComputedStyle(nextSection).backgroundColor;
      var currentBgImage = window.getComputedStyle(section).backgroundImage;
      var nextBgImage = window.getComputedStyle(nextSection).backgroundImage;
      if ((currentBgColor === 'rgb(255, 255, 255)' || currentBgColor === 'rgba(0, 0, 0, 0)') && (nextBgColor === 'rgb(255, 255, 255)' || nextBgColor === 'rgba(0, 0, 0, 0)') && currentBgImage === 'none' && nextBgImage === 'none') {
        section.style.setProperty('padding-bottom', '0', 'important');
      }
    }
  });
});
document.addEventListener("DOMContentLoaded", function () {
  var videos = document.querySelectorAll(".video-item");
  var loadMoreBtn = document.getElementById("load-more");
  var itemsToShow = 9;
  var currentItems = 9;
  if (videos && loadMoreBtn) {
    videos.forEach(function (video, index) {
      if (index >= itemsToShow) {
        video.style.display = "none";
      }
    });
    loadMoreBtn.addEventListener("click", function () {
      for (var i = currentItems; i < currentItems + itemsToShow; i++) {
        if (videos[i]) {
          videos[i].style.display = "block";
        }
      }
      currentItems += itemsToShow;
      if (currentItems >= videos.length) {
        loadMoreBtn.style.display = "none";
      }
    });
  }
});
jQuery(document).ready(function ($) {
  $('.modal').on('shown.bs.modal', function () {
    $("html").css({
      'overflow': 'hidden',
      'height': '100vh'
    });
  });
  $('.modal').on('hidden.bs.modal', function () {
    $("html").css({
      'overflow': 'auto',
      'height': 'auto'
    });
  });
});

// document.addEventListener('DOMContentLoaded', function () {
//   const videos = document.querySelectorAll('video');

//   videos.forEach(function (video) {
//       video.play().catch(function (error) {
//           // Handle the error if the browser prevents autoplay
//           console.log('Autoplay failed:', error);
//       });
//   });
// });